import { getVendorBillBalance } from './vendorFinanceSummary.js';

export function normalizeVendorBillTypeFilter(typeFilter) {
  if (!typeFilter || typeFilter === 'all' || typeFilter === 'All Bills') return 'all';
  const raw = String(typeFilter).trim().toLowerCase();
  const legacy = {
    'draft bills': 'draft',
    'open bills': 'open',
    'overdue bills': 'overdue',
    'paid bills': 'paid'
  };
  if (legacy[raw]) return legacy[raw];
  return raw.replace(/\s+bills?$/, '').trim();
}

function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isVendorBillOverdue(t) {
  if (!t || t.type !== 'Bill') return false;
  const bal = getVendorBillBalance(t);
  if (bal <= 0) return false;
  const st = String(t.status || '').toLowerCase();
  if (st === 'overdue') return true;
  if (st === 'paid' || st === 'cancelled' || st === 'canceled') return false;
  if (!t.dueDate) return false;
  const due = new Date(t.dueDate);
  if (Number.isNaN(due.getTime())) return false;
  due.setHours(0, 0, 0, 0);
  return due < startOfToday();
}

export function isVendorBillOpen(t) {
  if (!t || t.type !== 'Bill') return false;
  const st = String(t.status || '').toLowerCase();
  if (st === 'cancelled' || st === 'canceled' || st === 'paid') return false;
  if (st === 'draft' || st.includes('draft')) return false;
  return getVendorBillBalance(t) > 0;
}

export function filterVendorBillsByType(transactions, typeFilter) {
  const token = normalizeVendorBillTypeFilter(typeFilter);
  if (token === 'all') {
    return (transactions || []).filter((t) => t && t.type === 'Bill');
  }
  const bills = (transactions || []).filter((t) => t && t.type === 'Bill');
  switch (token) {
    case 'draft':
      return bills.filter((t) => {
        const st = String(t.status || '').toLowerCase();
        return st === 'draft' || st.includes('draft');
      });
    case 'open':
      return bills.filter((t) => isVendorBillOpen(t));
    case 'overdue':
      return bills.filter((t) => isVendorBillOverdue(t));
    case 'paid':
      return bills.filter((t) => {
        const st = String(t.status || '').toLowerCase();
        return st === 'paid' || getVendorBillBalance(t) <= 0;
      });
    default:
      return bills.filter((t) => String(t.status || '').toLowerCase() === token);
  }
}

export function filterVendorPayBillsByMethod(transactions, typeFilter) {
  if (!typeFilter || typeFilter === 'all') {
    return (transactions || []).filter((t) => t && t.type === 'Pay Bill');
  }
  return (transactions || []).filter((t) => {
    if (!t || t.type !== 'Pay Bill') return false;
    const paymentMethod = (t.paymentMethod || t.payMethod || 'Cash').trim();
    return paymentMethod === String(typeFilter).trim();
  });
}
